import { useContentfulResourcesMapped } from 'stores/Contentful/hooks'
import { Container } from 'shared/layout/Container'
import { Hero } from 'shared/layout/Hero'
import { Heading, Typography } from 'ui/typography'
import { Box, FlexBox, Stack } from 'ui/primitives'
import { RichText } from 'components/vendor/Contentful/richText/RichTextRenderer'
import { ResourceUtils } from 'services/ContentfulService/models/resource/utils'
import { aside, thanksForFeedbackTextBox } from '../ContactUs.css'
import { AsideItem } from '../../shared/Aside/AsideItem'
import ContentfulImage from 'experiences/shared/ContentfulImage'
import { ROUTES } from 'parameters/index'

export const Thanks = () => {
	const pageResources = useContentfulResourcesMapped()

	const ContentfulAsideIcon = ({ itemNum }: { itemNum: string }) => (
		<ContentfulImage
			asset={ResourceUtils(pageResources['about.aside.item_' + itemNum]).getMediaContent()}
			width={44}
			height={44}
			objectFit="contain"
			layout="fixed"
		/>
	)

	return (
		<>
			<Hero>
				<Heading.H1>Thanks for your feedback!</Heading.H1>
			</Hero>
			<Container>
				<FlexBox
					paddingY={{ xs: 'lg', md: 'xxl' }}
					gap={{ xs: 'lg', md: 'xxl' }}
					justifyContent="space-between"
					flexDirection={{ xs: 'column', md: 'row' }}
				>
					<Box className={thanksForFeedbackTextBox}>
						<RichText document={ResourceUtils(pageResources['body']).getRichContent()} />
					</Box>
					<Stack gap="lg" className={aside}>
						<Stack gap="sm">
							<Heading.H3>Financial Services</Heading.H3>
							<Typography>Get matched with the services you need.</Typography>
						</Stack>
						<AsideItem
							icon={<ContentfulAsideIcon itemNum="1" />}
							title={ResourceUtils(pageResources['about.aside.item_1']).getPlainTextContent()}
							link={{ href: ROUTES.PERSONAL_LOANS, text: 'Get Rates' }}
						/>
						<AsideItem
							icon={<ContentfulAsideIcon itemNum="2" />}
							title={ResourceUtils(pageResources['about.aside.item_2']).getPlainTextContent()}
							link={{ href: ROUTES.SAVINGS, text: 'See offers' }}
						/>
						<AsideItem
							icon={<ContentfulAsideIcon itemNum="3" />}
							title={ResourceUtils(pageResources['about.aside.item_3']).getPlainTextContent()}
							link={{ href: ROUTES.CREDIT_CARDS, text: 'See offers' }}
						/>
						<AsideItem
							icon={<ContentfulAsideIcon itemNum="4" />}
							title={ResourceUtils(pageResources['about.aside.item_4']).getPlainTextContent()}
							link={{ href: ROUTES.LIFE_INSURANCE, text: 'See offers' }}
						/>
					</Stack>
				</FlexBox>
			</Container>
		</>
	)
}
